(ns admin.components.forms.fields.completion-threshold
  (:require
   [reagent.core :as reagent]
   [reagent-form.utils :as rfu]

   [kyber.components.base.text :as text]
   [kyber.utils :as ku]
   [kyber.styles.core :refer [gs styles->classes]]))

(def classes
  (styles->classes
   {:container
    {:width "100%"
     :display :flex
     :flex-direction :column
     :padding (gs [:spacing :p20])
     :border (str "1px solid " (gs [:colors :gray-scale-300]))
     :border-radius (gs [:radius :r7])}

    :options-container
    {:display :flex
     :margin [(gs [:spacing :p20])
              (gs [:spacing :p0])]}

    :description-container
    {:border-top (str "1px solid " (gs [:colors :gray-scale-300]))
     :margin-top (gs [:spacing :p12])
     :padding-top (gs [:spacing :p12])}}))

(defn- update-custom-val
  [value {:keys [type] :as payload}]
  (cond-> payload
    (= :custom type)
    (assoc :value (some-> @value js/parseInt))))

(defn render
  [{:keys [node form-state]}]
  (let [params
        (second node)

        {:keys [default-value
                field-key
                plo-length
                plo-type]}
        (:rf/custom-field params)

        value
        (reagent/atom (:value default-value))]

    (rfu/ensure-field-key-or-throw field-key node)

    (rfu/initialize-field! form-state
                           field-key
                           {:default-errors []
                            :default-hints []
                            :default-value default-value
                            :hint-triggers []
                            :masks []
                            :transformers [(partial update-custom-val value)]
                            :validators []})
    (fn [{:keys [form-state]}]
      (let [selection (rfu/get-field-value @form-state field-key)]
        [:div {:class (:container classes)}
         [text/caption-30 :label "Activity Review Threshold"]

         (when (nil? plo-length)
           [text/caption-30 :p
            {:style {:color (gs [:colors :error-500])
                     :margin-top (gs [:spacing :p20])}}
            (str "The primary learning object must be uploaded and "
                 "processed before setting the review threshold.")])

         (when-not (nil? plo-length)
           [:<>
            [:div {:class (:options-container classes)}
             [:span
              [:input
               {:id :none
                :name field-key
                :type :radio
                :value :none
                :disabled (nil? plo-length)
                :checked (= :none (:type selection))
                :on-change #(rfu/update-field-value!
                             form-state
                             field-key
                             {:type :none
                              :value (reset! value nil)})}]
              [text/caption-20 :label {:for :none} "None"]]

             [:span {:style {:margin-left (gs [:spacing :p32])
                             :margin-right (gs [:spacing :p32])}}
              [:input
               {:id :end
                :name field-key
                :type :radio
                :value :end
                :disabled (nil? plo-length)
                :checked (= :end (:type selection))
                :on-change #(rfu/update-field-value!
                             form-state
                             field-key
                             {:type :end
                              :value (reset! value nil)})}]
              [text/caption-20 :label {:for :end}
               (case plo-type
                 "video" "End of Video"
                 "pdf" "End of Document"
                 nil)]]

             [:span
              [:input
               {:id :custom
                :name field-key
                :type :radio
                :value :custom
                :disabled (nil? plo-length)
                :checked (= :custom (:type selection))
                :on-change #(rfu/update-field-value!
                             form-state
                             field-key
                             {:type :custom
                              :value (if (nil? @value)
                                       (reset! value 0)
                                       @value)})}]
              [text/caption-20 :label {:for :custom} "Custom"]]]

            (when (= :custom (:type selection))
              [:input
               {:type :range
                :value @value
                :min 0
                :max (dec plo-length)
                :on-change
                #(reset! value (some-> % .-target .-value js/parseInt))}])])

         (when-not (nil? plo-length)
           [:div {:class (:description-container classes)}
            [text/caption-20 :p
             (case (:type selection)
               :none
               (case plo-type
                 "video" "Once the learner has started the video, they will be able to access Activity Review at any time."
                 "pdf" "The learner will be able to access Activity Review at any time, even if they have not read the document."
                 nil)

               :end
               (str "The learner will be able to access Activity Review at the end"
                    (case plo-type
                      "video" " of the video."
                      "pdf" " of the document."
                      nil))

               :custom
               (if (= @value 0)
                 (case plo-type
                   "video" "Once the learner has started the video, they will be able to access Activity Review at any time."
                   "pdf" "The learner will be able to access Activity Review at any time, even if they have not read the document."
                   nil)
                 
                 (str "The learner will be able to access Activity Review after reaching "
                      (case plo-type
                        "video" (-> @value
                                    (ku/seconds->time-string true)
                                    (ku/fmt-time-string))
                        "pdf" (str "page " (inc @value))
                        nil))))]])]))))




